
import { getData, postData, putData, deleteData } from "../apiClient";

const ItemName = "Setting";
const API_URL = "setting-list";

// get all with pagination
export const GetAll = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });

    const result = await getData(`/${API_URL}/?${queryParams}`, {}, {}, signal);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(`Get ${ItemName} with pagination API error:`, error);
    return {
      success: false,
      ...error,
    };
  }
};

// get item data with id
export const GetById = async (id) => {
  try {
    const result = await getData(`/${API_URL}/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get  ${ItemName} data API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const GetUserWebInfoByid = async (id) => {
  try {
    const result = await getData(`/${API_URL}/userwebinfo/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get  ${ItemName} data API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};
// create item ** // Updated Api Error Handle Method
export const Create = async ({ data }) => {
  try {
    const result = await postData(`/${API_URL}/`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Create ${ItemName} API error:`, error.status === 400 ? error.error : error.message);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};

// update item ** // Updated Api Error Handle Method
export const Update = async ({ id, data }) => {
  try {
    const result = await putData(`/${API_URL}/${id}`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Update ${ItemName} API error:`, error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};

// delete item
export const Delete = async ({ id }) => {
  try {
    const result = await deleteData(`/${API_URL}/${id}`);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Delete ${ItemName} API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const GetAllZonesTypes = async () => {
  try {
    const result = await getData(`/${API_URL}/zone/all`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Zone Type data API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const GetAllVehicleType = async () => {
  try {
    const result = await getData(`/${API_URL}/vehicle/all`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Vehicle Type data API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const GetAllTaxOptions = async () => {
  try {
    const result = await getData(`/${API_URL}/tax/all`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Tax Options API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

